export default class TelemetryService {
    // The parameter names are the contract this base class exists to document,
    // and the error message quotes them, so they are not underscore-prefixed to
    // appease the unused-vars rule.
    // eslint-disable-next-line no-unused-vars
    reportEvent(event, properties) {
        throw new Error("Method 'reportEvent(event, properties)' must be implemented.");
    }
    
    debugEvent(event, properties) {
        console.log(`TelemetryService.debugEvent(${event}, ${JSON.stringify(properties)})`);
    }
}